import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useAuth } from "../../context/AuthContext.jsx"; // Importando o contexto de autenticação
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import api from "../../services/api.js"; // Certifique-se de que o caminho está correto
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import logo from "../../assets/svg/logo.svg";
import instragramColorIcon from "../../assets/images/png/instagram_color.png";
import facebookColorIcon from "../../assets/images/png/facebook_color.png";
import tiktokColorIcon from "../../assets/images/png/tiktok_color.png";
import airbnbColorIcon from "../../assets/images/png/airbnb_color.png";
import spotifyColorIcon from "../../assets/images/png/spotify_color.png";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailForgotPassword, setEmailForgotPassword] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showTransition, setShowTransition] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const { login } = useAuth();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  /*   const isHD = useMediaQuery({ query: '(min-width: 769px) and (max-width: 1280px)' });
    const isFullHD = useMediaQuery({ query: '(min-width: 1281px)' }); */

  // Função para enviar as credenciais ao backend
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    console.log("[Login] Tentando login para:", email);

    try {
      const response = await api.post(
        "/api/login",
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("[Login] Resposta recebida:", response.data);
      if (
        response.data?.nickname &&
        response.data?.token &&
        response.data?.gender &&
        response.data?.id
      ) {
        login({
          nickname: response.data.nickname,
          token: response.data.token,
          userId: response.data.id,
          gender: response.data.gender,
          admin: response.data.admin,
        });
        setShowTransition(true);

        setTimeout(() => {
          console.log("[Login] Redirecionando para /home");
          navigate("/home");
        }, 1200);
      } else {
        console.log("[Login] Dados incompletos na resposta:", response.data);
        setErrorMessage("Erro ao autenticar. Tente novamente.");
      }
    } catch (error) {
      console.error("[Login] Erro ao autenticar:", error);
      setErrorMessage("Usuário e/ou senha incorretos");
    } finally {
      setLoading(false);
      console.log("[Login] Finalizado");
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("[ForgotPassword] Enviando e-mail para:", emailForgotPassword);

    try {
      await api.post("/api/forgot-password", { email: emailForgotPassword });
      console.log("[ForgotPassword] E-mail enviado com sucesso");
      setTabIndex(2);
    } catch (err) {
      console.error("[ForgotPassword] Erro ao enviar e-mail:", err);
      setErrorMessage("Houve um erro. Verifique o e-mail informado.");
    } finally {
      setLoading(false);
      console.log("[ForgotPassword] Finalizado");
    }
  };

  const handleToken = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(
      "[Token] Validando token:",
      token,
      "para e-mail:",
      emailForgotPassword
    );

    try {
      await api.post("/api/confirm-token", {
        email: emailForgotPassword,
        token,
      });
      console.log("[Token] Token validado com sucesso");
      setTabIndex(3);
    } catch (err) {
      console.error("[Token] Token inválido ou expirado:", err);
      setErrorMessage("Token inválido ou expirado.");
    } finally {
      setLoading(false);
      console.log("[Token] Finalizado");
    }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("[NewPassword] Redefinindo senha para:", emailForgotPassword);

    try {
      await api.post("/api/reset-password", {
        email: emailForgotPassword,
        token,
        password: newPassword,
        confirmpassword: confirmNewPassword,
      });
      console.log("[NewPassword] Senha redefinida com sucesso");
      setTabIndex(4);
    } catch (err) {
      console.error("[NewPassword] Erro ao redefinir senha:", err);
      setErrorMessage("Erro ao redefinir a senha.");
    } finally {
      setLoading(false);
      console.log("[NewPassword] Finalizado");
    }
  };

  return (
    <>
      <AnimatePresence>
        {showTransition && (
          <motion.div
            className="transition-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
          >
            <img src={logo} alt="Logo" className="transition-logo" />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        className="container-fluid vh-100 w-100 animated-background"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.5 }}
      >
        <div className="container-fluid vh-100 w-100">
          {!isMobile && (
            <div className="row vh-100">
              {/* Coluna esquerda: imagem e redes sociais */}
              <div className="col-md-6 d-flex flex-column justify-content-center align-items-center bg-1">
                <a href="/welcome">
                  <img src={logo} alt="Logo" width={300} className="mb-4" />
                </a>
                <p className="text-center mb-4 ">
                  Siga a República Sem Destino nas redes sociais!
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <a href="https://www.instagram.com/repsemdestino/">
                    <img
                      src={instragramColorIcon}
                      alt="Instagram"
                      className="social-icon"
                      width={30}
                    />
                  </a>
                  <a href="https://www.facebook.com/RepublicaSemDestino/">
                    <img
                      src={facebookColorIcon}
                      alt="Facebook"
                      className="social-icon"
                      width={30}
                    />
                  </a>
                  <a href="https://www.tiktok.com/@repsemdestino">
                    <img
                      src={tiktokColorIcon}
                      alt="Tiktok"
                      className="social-icon"
                      width={30}
                    />
                  </a>
                  <a href="https://www.airbnb.com.br/users/show/32669058">
                    <img
                      src={airbnbColorIcon}
                      alt="Airbnb"
                      className="social-icon"
                      width={30}
                    />
                  </a>
                </div>
                <p className="text-center mt-4">
                  Curta uma playlist no Spotify!
                </p>
                <a href="https://open.spotify.com/playlist/6ff3jEIwYZyFgiNwadFbvy?si=Kb-RsUhrQzqJpFUXgf6TSw&pi=1NuHtog3R8u5D">
                  <img
                    src={spotifyColorIcon}
                    className="social-icon"
                    alt="Spotify"
                    width={30}
                  />
                </a>
              </div>

              {/* Coluna direita: formulário de login */}

              <div className="col-md-6 d-flex justify-content-center align-items-center bg-2">
                <Tabs
                  style={{ width: "100%", maxWidth: "400px" }}
                  selectedIndex={tabIndex}
                  onSelect={setTabIndex}
                >
                  <TabList hidden>
                    <Tab />
                    <Tab />
                    <Tab />
                    <Tab />
                    <Tab />
                  </TabList>

                  {/* Login */}
                  <TabPanel>
                    <div
                      className="card p-4 shadow fade-in"
                      style={{ width: "100%", maxWidth: "400px" }}
                    >
                      <h3 className="text-center mb-4">Acesse sua conta</h3>

                      {errorMessage && (
                        <div className="alert alert-danger">{errorMessage}</div>
                      )}

                      <form onSubmit={handleLogin}>
                        {/* Campo de Email */}
                        <div className="mb-3 input-group">
                          <span className="input-group-text" id="basic-addon1">
                            <i class="bi bi-envelope-at"></i>
                          </span>
                          <input
                            type="email"
                            id="email"
                            className="form-control"
                            placeholder="Entre com seu e-mail"
                            value={email}
                            aria-label="Usuário"
                            aria-describedby="basic-addon1"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>

                        {/* Campo de Senha */}
                        <div className="mb-3 input-group">
                          <span className="input-group-text">
                            <i className="bi bi-key"></i> {/* Ícone de senha */}
                          </span>
                          <input
                            type="password"
                            id="password"
                            className="form-control"
                            placeholder="Entre com sua senha"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </div>

                        <button
                          type="submit"
                          className="btn btn-primary btn-lg rounded-pill w-100"
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Login"
                          )}
                        </button>
                      </form>
                      <p className="text-center mt-3">
                        <button
                          type="button"
                          className="btn btn-link text-decoration-none p-0"
                          style={{ color: "#0d6efd" }}
                          onClick={() => {
                            setTabIndex(1);
                            setErrorMessage("");
                          }}
                        >
                          Esqueci minha senha
                        </button>
                      </p>
                    </div>
                  </TabPanel>

                  {/* E-mail de recuperação */}
                  <TabPanel>
                    <div
                      className="card p-4 shadow fade-in"
                      style={{ width: "100%", maxWidth: "400px" }}
                    >
                      <h3 className="text-center mb-4">Digite seu e-mail</h3>
                      {errorMessage && (
                        <div className="alert alert-danger">{errorMessage}</div>
                      )}
                      <form onSubmit={handleForgotPassword}>
                        <div className="mb-3 input-group">
                          <span className="input-group-text">
                            <i class="bi bi-envelope-at"></i>
                          </span>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="seunome@email.com"
                            value={emailForgotPassword}
                            onChange={(e) =>
                              setEmailForgotPassword(e.target.value)
                            }
                            required
                          />
                        </div>
                        <button
                          className="btn btn-primary btn-lg rounded-pill w-100"
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Enviar"
                          )}
                        </button>
                        <p className="text-center mt-3">
                          <button
                            type="button"
                            className="btn btn-link text-decoration-none p-0"
                            style={{ color: "#0d6efd" }}
                            onClick={() => {
                              setTabIndex(0);
                              setErrorMessage("");
                            }}
                          >
                            Voltar
                          </button>
                        </p>
                      </form>
                    </div>
                  </TabPanel>

                  {/* Token de recuperação */}
                  <TabPanel>
                    <div
                      className="card p-4 shadow fade-in"
                      style={{ width: "100%", maxWidth: "400px" }}
                    >
                      <h3 className="text-center mb-4">
                        Digite o código recebido
                      </h3>
                      {errorMessage && (
                        <div className="alert alert-danger">{errorMessage}</div>
                      )}
                      <form onSubmit={handleToken}>
                        <input
                          type="text"
                          className="form-control mb-3"
                          value={token}
                          onChange={(e) => setToken(e.target.value)}
                          required
                        />
                        <button
                          className="btn btn-primary btn-lg rounded-pill w-100"
                          disabled={loading}
                        >
                          {loading ? "Validando..." : "Validar"}
                        </button>
                        <p className="text-center mt-3">
                          <button
                            type="button"
                            className="btn btn-link text-decoration-none p-0"
                            style={{ color: "#0d6efd" }}
                            onClick={() => {
                              setTabIndex(1);
                              setErrorMessage("");
                            }}
                          >
                            Voltar
                          </button>
                        </p>
                      </form>
                    </div>
                  </TabPanel>

                  {/* Nova senha */}
                  <TabPanel>
                    <div
                      className="card p-4 shadow fade-in"
                      style={{ width: "100%", maxWidth: "400px" }}
                    >
                      <h3 className="text-center mb-4">Nova senha</h3>
                      {errorMessage && (
                        <div className="alert alert-danger">{errorMessage}</div>
                      )}
                      <form onSubmit={handleNewPassword}>
                        <input
                          type="password"
                          className="form-control mb-3"
                          placeholder="Nova senha"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                        />
                        <input
                          type="password"
                          className="form-control mb-3"
                          placeholder="Confirmar senha"
                          value={confirmNewPassword}
                          onChange={(e) =>
                            setConfirmNewPassword(e.target.value)
                          }
                          required
                        />
                        <button
                          className="btn btn-primary btn-lg rounded-pill w-100"
                          disabled={loading}
                        >
                          {loading ? "Salvando..." : "Redefinir senha"}
                        </button>
                      </form>
                    </div>
                  </TabPanel>

                  {/* Senha redefinida com sucesso */}
                  <TabPanel>
                    <div
                      className="card p-4 shadow fade-in"
                      style={{ width: "100%", maxWidth: "400px" }}
                    >
                      <h3 className="text-center mb-4">
                        Senha redefinida com sucesso!
                      </h3>
                      <button
                        className="btn btn-primary btn-lg rounded-pill w-100"
                        onClick={() => setTabIndex(0)}
                      >
                        Voltar para login
                      </button>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          )}
          {isMobile && (
            <div className="col vh-100 d-flex flex-column justify-content-center align-items-center gap-3">
              {/* Logo */}
              <div className="mt-4">
                <a href="/welcome">
                  <img
                    src={logo}
                    alt="Logo"
                    className="mb-2"
                    style={{ width: "116px" }}
                  />
                </a>
              </div>

              <Tabs
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  justifyContent: "center",
                  display: "flex",
                }}
                selectedIndex={tabIndex}
                onSelect={setTabIndex}
              >
                <TabList hidden>
                  <Tab />
                  <Tab />
                  <Tab />
                  <Tab />
                  <Tab />
                </TabList>

                {/* Login */}
                <TabPanel style={{ width: "100%" }}>
                  <div
                    className="card p-4 shadow fade-in"
                    style={{ width: "100%", maxWidth: "400px" }}
                  >
                    <h3 className="text-center mb-4">Acesse sua conta</h3>

                    {errorMessage && (
                      <div className="alert alert-danger">{errorMessage}</div>
                    )}

                    <form onSubmit={handleLogin}>
                      {/* Campo de Usuário */}
                      <div className="mb-3 input-group">
                        <span className="input-group-text" id="basic-addon1">
                          <i class="bi bi-envelope-at"></i>
                        </span>
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Entre com seu e-mail"
                          value={email}
                          aria-label="Usuário"
                          aria-describedby="basic-addon1"
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>

                      {/* Campo de Senha */}
                      <div className="mb-3 input-group">
                        <span className="input-group-text">
                          <i className="bi bi-key"></i> {/* Ícone de senha */}
                        </span>
                        <input
                          type="password"
                          id="password"
                          className="form-control"
                          placeholder="Entre com sua senha"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary btn-lg rounded-pill w-100"
                        disabled={loading}
                      >
                        {loading ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          "Login"
                        )}
                      </button>
                    </form>
                    <p className="text-center mt-3">
                      <button
                        type="button"
                        className="btn btn-link text-decoration-none p-0"
                        style={{ color: "#0d6efd" }}
                        onClick={() => {
                          setTabIndex(1);
                          setErrorMessage("");
                        }}
                      >
                        Esqueci minha senha
                      </button>
                    </p>
                  </div>
                </TabPanel>

                {/* Esqueci minha senha */}
                <TabPanel style={{ width: "100%" }}>
                  <div
                    className="card p-4 shadow fade-in"
                    style={{ width: "100%", maxWidth: "400px" }}
                  >
                    <h3 className="text-center mb-4">Digite seu e-mail</h3>
                    {errorMessage && (
                      <div className="alert alert-danger">{errorMessage}</div>
                    )}
                    <form onSubmit={handleForgotPassword}>
                      <div className="mb-3 input-group">
                        <span className="input-group-text">
                          <i class="bi bi-envelope-at"></i>
                        </span>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="seunome@email.com"
                          value={emailForgotPassword}
                          onChange={(e) =>
                            setEmailForgotPassword(e.target.value)
                          }
                          required
                        />
                      </div>
                      <button
                        className="btn btn-primary btn-lg rounded-pill w-100"
                        disabled={loading}
                      >
                        {loading ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          "Enviar"
                        )}
                      </button>
                      <p className="text-center mt-3">
                        <button
                          type="button"
                          className="btn btn-link text-decoration-none p-0"
                          style={{ color: "#0d6efd" }}
                          onClick={() => {
                            setTabIndex(0);
                            setErrorMessage("");
                          }}
                        >
                          Voltar
                        </button>
                      </p>
                    </form>
                  </div>
                </TabPanel>

                {/* Token de recuperação */}
                <TabPanel style={{ width: "100%" }}>
                  <div
                    className="card p-4 shadow fade-in"
                    style={{ width: "100%", maxWidth: "400px" }}
                  >
                    <h3 className="text-center mb-4">
                      Digite o código recebido
                    </h3>
                    {errorMessage && (
                      <div className="alert alert-danger">{errorMessage}</div>
                    )}
                    <form onSubmit={handleToken}>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                        required
                      />
                      <button
                        className="btn btn-primary btn-lg rounded-pill w-100"
                        disabled={loading}
                      >
                        {loading ? "Validando..." : "Validar"}
                      </button>
                      <p className="text-center mt-3">
                        <button
                          type="button"
                          className="btn btn-link text-decoration-none p-0"
                          style={{ color: "#0d6efd" }}
                          onClick={() => {
                            setTabIndex(1);
                            setErrorMessage("");
                          }}
                        >
                          Voltar
                        </button>
                      </p>
                    </form>
                  </div>
                </TabPanel>

                {/* Nova senha */}
                <TabPanel style={{ width: "100%" }}>
                  <div
                    className="card p-4 shadow fade-in"
                    style={{ width: "100%", maxWidth: "400px" }}
                  >
                    <h3 className="text-center mb-4">Nova senha</h3>
                    {errorMessage && (
                      <div className="alert alert-danger">{errorMessage}</div>
                    )}
                    <form onSubmit={handleNewPassword}>
                      <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="Nova senha"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                      <input
                        type="password"
                        className="form-control mb-3"
                        placeholder="Confirmar senha"
                        value={confirmNewPassword}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        required
                      />
                      <button
                        className="btn btn-primary btn-lg rounded-pill w-100"
                        disabled={loading}
                      >
                        {loading ? "Salvando..." : "Redefinir senha"}
                      </button>
                    </form>
                  </div>
                </TabPanel>

                {/* Senha redefinida com sucesso */}
                <TabPanel style={{ width: "100%" }}>
                  <div
                    className="card p-4 shadow fade-in"
                    style={{ width: "100%", maxWidth: "400px" }}
                  >
                    <h3 className="text-center mb-4">
                      Senha redefinida com sucesso!
                    </h3>
                    <button
                      className="btn btn-primary btn-lg rounded-pill w-100"
                      onClick={() => setTabIndex(0)}
                    >
                      Voltar para login
                    </button>
                  </div>
                </TabPanel>
              </Tabs>
              {/* Redes sociais */}
              <div className="text-center mb-4">
                <div className="d-flex justify-content-center gap-3">
                  <a href="https://www.instagram.com/repsemdestino/">
                    <img
                      src={instragramColorIcon}
                      alt="Instagram"
                      className="social-icon"
                      width={30}
                    />
                  </a>
                  <a href="https://www.facebook.com/RepublicaSemDestino/">
                    <img
                      src={facebookColorIcon}
                      alt="Facebook"
                      className="social-icon"
                      width={30}
                    />
                  </a>
                  <a href="https://www.tiktok.com/@repsemdestino">
                    <img
                      src={tiktokColorIcon}
                      alt="TikTok"
                      className="social-icon"
                      width={30}
                    />
                  </a>
                  <a href="https://www.airbnb.com.br/users/show/32669058">
                    <img
                      src={airbnbColorIcon}
                      alt="Airbnb"
                      className="social-icon"
                      width={30}
                    />
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </motion.div>
    </>
  );
};

export default LoginPage;
